// extracted by mini-css-extract-plugin
module.exports = {"BigGlobe":"BigGlobe_BigGlobe__3KEdI"};